export default function PartnershipsPage() {
  return (
    <div className="min-h-screen bg-background">
      <div className="max-w-2xl mx-auto px-6 py-16">
        <h1 className="text-3xl font-bold mb-2">Work with RoleRound</h1>
        <p className="text-muted-foreground text-sm mb-12">
          We partner with students, organizations, and institutions who want to help people walk
          into interviews prepared.
        </p>

        <div className="space-y-12">
          {/* Ambassador */}
          <section className="space-y-3">
            <h2 className="text-xl font-semibold">Campus Ambassador</h2>
            <p className="text-muted-foreground">
              Represent RoleRound at your college or university. Ambassadors help spread the word to
              students preparing for internships and full-time roles — and get free Pro access in
              return.
            </p>
            <p className="text-muted-foreground">
              We're early and keep this informal. If you're a student who believes in what we're
              building and wants to be part of it, reach out.
            </p>
            <a
              href="/contact?subject=Campus+Ambassador"
              className="inline-flex items-center gap-2 bg-primary text-primary-foreground font-medium px-5 py-2.5 rounded-lg hover:opacity-90 transition-opacity text-sm"
            >
              Get in touch →
            </a>
          </section>

          <div className="border-t" />

          {/* Career Centers & Student Orgs */}
          <section className="space-y-3">
            <h2 className="text-xl font-semibold">Career Centers & Student Organizations</h2>
            <p className="text-muted-foreground">
              We work with career centers, pre-professional clubs, and student organizations that
              want to give their members access to structured interview practice.
            </p>
            <p className="text-muted-foreground">
              We're still early — if you're interested, reach out and we'll figure out something
              that works.
            </p>
            <a
              href="/contact?subject=Career+Center+or+Student+Org"
              className="inline-flex items-center gap-2 bg-primary text-primary-foreground font-medium px-5 py-2.5 rounded-lg hover:opacity-90 transition-opacity text-sm"
            >
              Get in touch →
            </a>
          </section>

          <div className="border-t" />

          {/* University Partnerships */}
          <section className="space-y-3">
            <h2 className="text-xl font-semibold">University Partnerships</h2>
            <p className="text-muted-foreground">
              Longer-term, we're building tools for career advisors — cohort tracking, progress
              dashboards, and bulk seat licensing.
            </p>
            <p className="text-muted-foreground text-sm text-muted-foreground/70">
              This is on the roadmap for 2027. If you want early access when it's ready, let us
              know.
            </p>
            <a
              href="/contact?subject=University+Partnership"
              className="inline-flex items-center gap-2 border border-input bg-background font-medium px-5 py-2.5 rounded-lg hover:bg-muted transition-colors text-sm"
            >
              Express interest →
            </a>
          </section>
        </div>

        <div className="border-t mt-12 pt-8">
          <p className="text-sm text-muted-foreground">
            <a href="/privacy" className="text-primary underline underline-offset-2">
              Privacy Policy
            </a>
            {' · '}
            <a href="/terms" className="text-primary underline underline-offset-2">
              Terms of Service
            </a>
            {' · '}
            <a href="/" className="text-primary underline underline-offset-2">
              ← Back to RoleRound
            </a>
          </p>
        </div>
      </div>
    </div>
  )
}
